var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#FF0000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.79708 25.9956C6.51137 21.5402 10.7624 17.5075 15.2952 17.5075C19.7753 17.5075 23.7332 21.447 25.3676 25.8403C28.2222 23.1095 30 19.2624 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 19.3438 1.84636 23.2563 4.79708 25.9956ZM21.3284 9.04479C21.3284 12.3832 18.6221 15.0896 15.2836 15.0896C11.9452 15.0896 9.23885 12.3832 9.23885 9.04479C9.23885 5.70635 11.9452 3 15.2836 3C18.6221 3 21.3284 5.70635 21.3284 9.04479Z",
    fill: "#F5B6B6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.74f26b0e460e63f9b873545972fe2cb1.svg";
export { ForwardRef as ReactComponent };